const departments = {
    leader: 'Responsable',
    leaders: 'Responsables du département',
    led_departments: 'Départements dirigés',
    edit_leaders: 'Gérer les responsables',
    add_leader: 'Ajouter',
    remove_leader: 'Retirer',
    no_leaders: 'Aucun responsable',
    local: 'Gestion locale',
    managed_members: 'Membres du périmètre géré',
    leader_scope_hint: 'Gérez les affectations de vos départements et sous-départements.',
    leader_permission_hint: 'Les responsables gèrent les affectations de leurs départements et sous-départements, sans modifier les rôles ni la hiérarchie.',
    primary_synced: 'Le département principal est géré par Feishu.',
    status_active: 'Actif',
    status_suspended: 'Suspendu',
    status_departed: 'Parti',
    status_pending: 'Activation en attente',
    search: 'Rechercher',
    previous_page: 'Page précédente',
    next_page: 'Page suivante',
    directory_title: 'Membres de l’organisation',
    member_name: 'Membre',
    search_members: 'Rechercher par nom ou identifiant',
    include_descendants: 'Inclure les sous-services',
    no_members: 'Aucun membre correspondant.',
    all_members: 'Tous les membres',
    all_departments: 'Tous les services',
    edit_member: 'Modifier les services',
    add_child: 'Ajouter un sous-service',
    expand_department: 'Développer {{name}}',
    collapse_department: 'Réduire {{name}}',
    title: 'Départements',
    description: 'Gérez les départements et les affectations des membres de cette organisation.',
    create: 'Créer un département',
    edit: 'Modifier le département',
    name: 'Nom du département',
    parent: 'Département parent',
    root: 'Aucun département parent',
    id: 'ID du département',
    members: 'Départements des membres',
    member_id: 'ID utilisateur du membre',
    primary: 'Département principal',
    none: 'Non défini',
    assignments: 'Affectations aux départements',
    no_assignments: 'Aucune affectation pour le moment.',
    assignment_hint: 'Affectez des départements locaux et éventuellement un département principal. Les affectations de l’annuaire sont en lecture seule.',
    empty: 'Aucun département pour le moment.',
    readonly: 'Vous pouvez consulter les départements et vos affectations. Contactez un administrateur pour les modifier.',
    load_error: 'Impossible de charger les données. Réessayez.',
    mutation_error: 'Enregistrement impossible. Vérifiez vos droits, votre appartenance et la hiérarchie des départements.',
    loading: 'Chargement…',
    synced: 'Géré par l’annuaire',
    choose: 'Rechercher des départements',
    organizations_title: 'Organisations et départements',
    organizations_description: 'Choisissez une organisation pour consulter ou gérer ses départements.',
    no_organizations: 'Vous ne faites partie d’aucune organisation. Contactez un administrateur.',
    organization: 'Organisation actuelle',
    choose_organization: 'Choisissez une organisation',
    delete_title: 'Supprimer le département',
    delete_description: 'Supprimer « {{name}} » ? Déplacez d’abord ses membres et sous-départements.',
};
export default Object.freeze(departments);
